/**
 * Utility for image processing and resizing.
 */

export const resizeImage = (file, maxDimension = 1200) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                let width = img.width;
                let height = img.height;

                if (width > maxDimension || height > maxDimension) {
                    if (width > height) {
                        height *= maxDimension / width;
                        width = maxDimension;
                    } else {
                        width *= maxDimension / height;
                        height = maxDimension;
                    }
                }

                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);
                // Using jpeg with quality 0.8 significantly reduces base64 size
                resolve(canvas.toDataURL("image/jpeg", 0.8));
            };
            img.onerror = (err) => reject(new Error("Image loading failed: " + err));
            img.src = e.target.result;
        };
        reader.onerror = (err) => reject(new Error("File reading failed: " + err));
        reader.readAsDataURL(file);
    });
};

/**
 * Validates and processes an image file from an input event.
 * @param {File} file - The file to process.
 * @returns {Promise<string>} - The resized base64 string.
 */
export const processImageUpload = async (file) => {
    if (!file) return null;
    
    // Simple validation
    const validTypes = ['image/jpeg', 'image/png', 'image/webp'];
    if (!validTypes.includes(file.type)) {
        throw new Error("Please upload a valid image file (JPEG, PNG, or WEBP).");
    }

    try {
        return await resizeImage(file);
    } catch (error) {
        console.error("Image processing failed:", error);
        // Fallback to original reader if resizing fails
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }
};
